export default __webpack_public_path__ + "static/media/files.cdc2a911.svg";